import { AppNavigation } from '@euler/app/components/AppNavigationProvider';
import { openAiChat } from '@euler/app/flows/ai-suite/openAiChat';
import { aiSuiteToolForFeature } from '@euler/app/flows/ai-suite/theme';
import { AiAgentBundleId, AiHomeFeature } from '@euler/model/ai-home';

/**
 * Opens a 知车 AI conversation with the sales coach, starting from the
 * trainee's own words about their situation.
 */
export function openCoachingSetup(navigation: AppNavigation, text: string) {
  openAiChat(navigation, {
    kind: 'new',
    tool: aiSuiteToolForFeature(AiHomeFeature.Coaching),
    bundleId: AiAgentBundleId.SalesCoaching,
    message: { text, attachments: [] },
  });
}

/**
 * Opens the coach on a library case the trainee picked. The case travels by
 * id, so the coach briefs exactly this case; the words only name it in the
 * conversation.
 */
export function openCoachingCase(
  navigation: AppNavigation,
  practise: { caseId: string; title: string },
) {
  openAiChat(navigation, {
    kind: 'new',
    tool: aiSuiteToolForFeature(AiHomeFeature.Coaching),
    bundleId: AiAgentBundleId.SalesCoaching,
    message: {
      text: `我想练「${practise.title}」`,
      attachments: [],
      tap: { kind: 'coaching_case', caseId: practise.caseId },
    },
  });
}
